import { Interval } from '@zapier/design-system-revenue/src/types';

type Props = {
  accountAgeDays: number | undefined;
  currentPlanInterval: Interval | undefined;
  currentUserRole: 'admin' | 'member' | 'owner' | undefined;
  yearlyDiscountPercentage: number | undefined;
};

export const isEligibleForAnnualUpgrade = ({
  accountAgeDays,
  currentPlanInterval,
  currentUserRole,
  yearlyDiscountPercentage,
}: Props) => {
  if (
    accountAgeDays === undefined || // don't return false if this is 0
    !currentPlanInterval ||
    !currentUserRole ||
    !yearlyDiscountPercentage
  ) {
    return false;
  }

  return (
    currentPlanInterval === 'month' &&
    yearlyDiscountPercentage > 0 &&
    accountAgeDays < 45 &&
    ['admin', 'owner'].includes(currentUserRole)
  );
};
